import { transform } from 'framer-motion';

const widthToPercentage = transform([0, 428], ['0%', '100%'], {
  clamp: false,
});

const heightToPercentage = transform([0, 926], ['0%', '100%'], {
  clamp: false,
});

const designScreenRatio = 428 / 926;

export { designScreenRatio, heightToPercentage, widthToPercentage };
